import { Action } from 'redux';

interface ActionWithPayload extends Action {
  payload: any;
}

export default (handlers: object, initialState: object) => (
  state = initialState,
  { type, payload }: ActionWithPayload
): object =>
  handlers.hasOwnProperty(type) ? handlers[type](state, payload) : state;
